<template>
  <AppToast
    :show="showScheduleReportToast"
    title="Schedule this report?"
    message="Scheduled reports are automatically sent to your email according to the schedule you set"
    @close="dismiss"
  >
    <template #footer>
      <button
        type="button"
        class="btn btn-full-width btn-primary"
        @click="openDialog"
      >
        Schedule
      </button>
      <button
        type="button"
        class="btn btn-full-width btn-outline-default"
        @click="dismiss"
      >
        Not now
      </button>
    </template>
  </AppToast>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ReportsMixin from '~/mixins/reports/ReportsMixin';
import AppToast from '~/components/AppToast.vue';
import { UserOrganizationsResource } from '~/resources';

export default {
  name: 'ScheduleReportToast',
  components: {
    AppToast,
  },
  mixins: [ReportsMixin],
  computed: {
    ...mapGetters(['showScheduleReportToast']),
    ...mapState({
      currentUserOrganizationId: 'current_user_organization_id',
    }),
  },
  methods: {
    ...mapActions(['closeScheduleReportToast']),
    close() {
      this.$emit('close');
    },
    openDialog() {
      this.$emit('open-dialog');
      this.dismiss();
    },
    async dismiss() {
      try {
        const response = await UserOrganizationsResource.dismissDialog(
          { id: this.currentUserOrganizationId },
          { dialog: 'schedule_report' },
          { abortReload: true },
        );

        if (response?.errors) {
          this.$appMessage('Error dismissing dialog');
        }
      } catch (error) {
        if (![401, 403].includes(error.status)) {
          this.$appMessage('Unexpected error. Please try again.');
        }
      } finally {
        this.closeScheduleReportToast();
        this.close();
      }
    },
  },
};
</script>
